import React from 'react';

import {Select} from 'Components/Form';

// Check out the Duality Portal "Add Version Control to Model" Wiki for guidance.

/**
 * @function DeletedFilter
 * @param {string|null} containerClassName
 * @param {function} onChange
 * @param {object} filters
 * @param {string} column
 * @param {string} label
 * @constructor
 */
const DeletedFilter = ({containerClassName, onChange, filters, column, label}) => {
	let column_key = 'deleted';

    return (
        <Select
            containerClassName={containerClassName ?? "w-64"}
            label={label}
            placeholder="Filter..."
            onChange={(v) => onChange(column_key, v)}
            value={filters && filters[column_key] ? filters[column_key] : 'onlyLive'}
            options={[
                {
                    label: 'Live and Deleted Records',
                    value: 'withTrashed'
                },
                {
                    label: 'Deleted Records Only',
                    value: 'onlyTrashed'
                },
                {
                    label: 'Live Records Only',
                    value: 'onlyLive'
                }
            ]}
        />
    );
};

export default DeletedFilter;
